/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_A_Fewer_FinalsInputs */



/**
* | output |
* | --- |
* | "No. Finals require exactly 5 eligible (non-DQ'd) players. If a DQ'd player is in the top 5, the 6th-place player takes their spot." |
*
* @param {Og_Faq_A_Fewer_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_a_fewer_finals = /** @type {((inputs?: Og_Faq_A_Fewer_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_A_Fewer_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non. La finale nécessite exactement 5 joueurs éligibles (non disqualifiés). Si un joueur DQ'd est dans le top 5, le joueur en 6ème place prend sa place.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No. Las finales requieren exactamente 5 jugadores elegibles (no descalificados). Si un jugador descalificado está en el top 5, el jugador en 6.ª posición toma su lugar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não. A final requer exatamente 5 jogadores elegíveis (não desqualificados). Se um jogador desqualificado estiver no top 5, o jogador em 6º lugar assume seu lugar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("No. Le finali richiedono esattamente 5 giocatori idonei (non squalificati). Se un giocatore squalificato è nel top 5, il giocatore al 6° posto prende il suo posto.")
	return /** @type {LocalizedString} */ ("No. Finals require exactly 5 eligible (non-DQ'd) players. If a DQ'd player is in the top 5, the 6th-place player takes their spot.")
});